const firebaseConfig = {
    apiKey: "AIzaSyDFQGo2X7zdDSZIWUKAIqSIS5FnIBuEVRY",
    authDomain: "easy-fix-affce.firebaseapp.com",
    projectId: "easy-fix-affce",
    storageBucket: "easy-fix-affce.appspot.com",
    messagingSenderId: "649352026428",
    appId: "1:649352026428:web:310ba582bda12431e0a639",
};

export default firebaseConfig;
